import type { VoidFunctionComponent } from 'react';
import { useSelector } from 'react-redux';
import type { SortOption } from '../../../shared/organizationPackages/sortOptions';
import * as PackageInventoryStore from '../../redux/packageInventory';
import DropdownButton from '../generic/DropdownButton';
import useFetchPackages from './hooks/useFetchPackages';
import type { WithResetSelectedPackage } from './PackageInventoryContainer';
import { Icon, icons } from '../generic';

const sortLabel: Record<SortOption, string> = Object.freeze({
  usage: 'Usage',
  alphabetical: 'Package (A-Z)',
  match: 'Match',
});

const PackageSortingDropdown: VoidFunctionComponent<{ withResetSelectedPackage: WithResetSelectedPackage }> = ({
  withResetSelectedPackage,
}) => {
  const sort = useSelector(PackageInventoryStore.selectors.getSortOrDefault);
  const packageName = useSelector(PackageInventoryStore.selectors.getFiltersPackageName);
  const setSort = withResetSelectedPackage(useFetchPackages(PackageInventoryStore.actions.setPackagesSort));
  return (
    <DropdownButton
      id="PackageSortingDropdown"
      title={
        <span>
          <Icon icon={icons.sortDescending} /> {sortLabel[sort]}
        </span>
      }
      onSelect={setSort}
      size="small"
      pullRight
    >
      {!packageName && (
        <DropdownButton.Item key="alphabetical" eventKey="alphabetical" active={sort === 'alphabetical'}>
          {sortLabel.alphabetical}
        </DropdownButton.Item>
      )}
      {packageName && (
        <DropdownButton.Item key="match" eventKey="match" active={sort === 'match'}>
          {sortLabel.match}
        </DropdownButton.Item>
      )}
      <DropdownButton.Item key="usage" eventKey="usage" active={sort === 'usage'}>
        {sortLabel.usage}
      </DropdownButton.Item>
    </DropdownButton>
  );
};

export default PackageSortingDropdown;
